<template>
<div>
    <Header title="缴费记录" />
    <div class="header">
        <div class="top">
            <p>附加课程：</p>
            <div class="tag-item" v-for="(item, index) in dataSources.append_subject" :key="index">{{item}}</div>
        </div>
        <div class="center">
            <div class="text">
                <p>当前等级：{{dataSources.axle_type_text}}</p>
                <span>还差{{dataSources.lack}}升级{{dataSources.user_subject_next_name}}</span>
            </div>
            <div class="slider">
                <div :style="showPercentage"></div>
            </div>
        </div>
    </div>
    <div class="list-header">
        <img :src="Images.icon_bill" alt="">
        <p>缴费记录</p>
    </div>
    <div class="scrollerView" :style="{ height: (wrapperHeight- 255) + 'px' }">
        <scroller :on-refresh="_onRefresh" :on-infinite="_onEndReached" :noDataText="listData.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
            <billItem v-for="(item, _index) in listData" :key="_index" :item="item" />
            <van-empty description="暂无信息～" v-if="listData.length < 1 && !loading" />
        </scroller>
    </div>
</div>
</template>

<script>
import Header from '@/components/Header'
import billItem from '@/components/item/billItem'
export default {
    components: {
        'Header': Header,
        'billItem': billItem,
    },
    computed: {
        showPercentage() {
            return 'width: ' + (this.dataSources.percentage || 0) + '%;';
        }
    },
    data() {
        return {
            loading: false,
            wrapperHeight: 0,
            page: 0,
            limit: 10,
            dataSources: {},
            listData: [],
            income: {},
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this._requestDataSources();
    },
    methods: {
        
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        async _requestDataSources() {
            let url = this.API.my_pay_record;
            let data = {
                page: this.page,
                limit: this.limit,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.listData.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.dataSources = result.data;
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.listData = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.header {
    width: 100vw;
    height: 160px;
    box-sizing: border-box;
    padding: 16px 20px;
    background-image: url('../../assets/img/img_page_bg1.png');
    background-size: cover;
    background-position: bottom;

    .top {
        margin-bottom: 30px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #fff;
        }

        div {
            height: 22px;
            width: 60px;
            border-radius: 3px 11px 11px 11px;
            background: linear-gradient(270deg, #FFAD3F, #FFC050);
            font-size: 13px;
            color: #fff;
            line-height: 22px;
            text-align: center;
        }
    }

    .center {

        .text {
            margin-bottom: 8px;
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 13px;
                color: #fff;
            }

            span {
                font-size: 12px;
                color: #fff;
            }
        }

        .slider {
            width: 100%;
            height: 8px;
            border-radius: 4px;
            background: linear-gradient(270deg, rgba(255, 255, 255, 0.00), #ffffff);

            div {
                height: 8px;
                border-radius: 4px;
                background: #fff;
            }
        }
    }
}

.list-header {
    padding: 0 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-end;

    img {
        width: 20px;
        height: 22px;
        margin-right: 10px;
    }

    p {
        font-size: 15px;
        color: #333;
    }
}
</style>
